<script lang="ts">
import { useBalance } from '@/composables/useBalance'
import { useToken } from '@/composables/useToken'
import debounce from 'lodash-es/debounce'
import { watch, nextTick } from 'vue'
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'PageChange',
  setup() {
    // 监听路由变化
    const { recycleBalance } = useBalance()
    const { isLoggedIn } = useToken()
    const route = useRoute()
    // 从部分路由离开需要更新余额
    const needUpdateBalance = ['/embedded', '/promotions']
    const debouncedGetBalance = debounce(
      async () => {
        recycleBalance()
      },
      1000,
      { maxWait: 5000 }
    )
    watch(
      () => route?.path,
      async (cur, pre) => {
        console.log('[PageChange] ', 'from:', pre, 'to:', cur)
        if (isLoggedIn.value && needUpdateBalance.includes(pre)) {
          debouncedGetBalance()
        }
      }
    )
  },
  render() {
    return null
  }
})
</script>
